<template>
  <!-- eslint-disable -->
  <div class="navbar">

    <div class="navbar-left">
      <hamburger :toggle-click="toggleSideBar" :is-active="sidebar.opened" class="hamburger-container" />

      <breadcrumb class="breadcrumb-container" />
    </div>
    <div class="right-menu">
      <div v-if="device!=='mobile'" class="right-menu-actions">
        <div class="user-info-section">
          <span class="welcome-text">Hello,  <span class="name-shimmer">{{ name }}</span></span>
          <span v-if="baseApiData" class="env-indicator" :title="baseApiData.api_name">《{{ baseApiData.api_name }}》</span>
        </div>
        <div class="search-section">
          <search id="header-search" class="search-component" />
        </div>
        <div class="tools-section">
          <!-- bi灵犀 入口 -->
          <el-tooltip v-if="checkPermission(['bi_user_platform'])" content="BI灵犀" effect="dark" placement="bottom">
            <a href="https://bi.shjinjia.com.cn/webroot/decision?force_web=true" target="_blank" class="right-menu-item">
              <svg
                id="Layer_1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                version="1.1"
                class="icon cl10"
                x="0px"
                y="0px"
                width="20px"
                height="20px"
                viewBox="0 0 30 30"
                enable-background="new 0 0 30 30"
                xml:space="preserve"
              >  <image id="image0" width="30" height="30" x="0" y="0" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAMAAAAM7l6QAAAAIGNIUk0AAHomAACAhAAA+gAAAIDo AAB1MAAA6mAAADqYAAAXcJy6UTwAAAGhUExURQAAAP////X19QAAAAAAAAAAAPr6+vj4+OHh4efn 5+zs7PLy8vj4+Onp6fPz8wAAAAAAAAAAAAAAAAAAAAAAAPf39xiIySuj3PLy8u/v79PT0/f39/b2 9m1tbRqNzi6n4AdzvRqMzB2QzyCV0iSa1hSCxBaFxy6m4C6n4BB9whKAwxWDxheGySqi3Cyl3xF/ wxODxBaGxymg2yuj3S2m3xyOzh6S0SCV0wRstQNstQVvtw58wRF/xBqNzh2Q0B+T0iig2wNttgRu twt3vg17wBB/wxKBxRmLzBuOzx6R0SWb2Cee2iqh3Cyk3gNttwl3vQx6vw59wRGAxSSZ1yac2Cif 2i6n3wh1vAt4vw17wQ9+wyKX1SWb1yee2Smh3ANutwdzvAl2vgx5wA59whWGyReJyxqMzRiKzCCU 0wZyugh1vQp4vxSEyBaHyhSFyByPzyOZ1gNuuARwuQdzuwt5wBODxi2l3wVxugh0vAp3vyuj3gl2 vSad2QRvuQZyuyWc2Ax6wSKW1A99wx2R0Qp3vgx6wAt4wBKCxiGW1CSa1////7QW09MAAAAldFJO UwBaNAMCATNKKyopKCcXPgkIBwYFBD3t+j0vHUI8By7qcwwHCBJU7ijfAAAAAWJLR0QB/wIt3gAA AAlwSFlzAAAOwwAADsMBx2+oZAAAAAd0SU1FB+gICQkVD9Ng9w4AAAF7SURBVCjPxdBXU8JAEADg 1dxZsIKx9x57AXvFhhUrCrYYK2I9LNh7/dduSAhBGF/dmdvZy5e9nVmI0kc0RyiloItQJn9yjMwQ yrFxcfHxBoMhISExKQInp6QajaY0nue4sLeR0/1aXpGhamaloOcso8mUVlVdU+tXCnX1gqDjbFSe a2hsUhSazRZ9d05wbEtrG4RGVG57RydqVzdyT28ffuo3YxKUCXn5HdYBQgaHhkcAbKNjAOMTk1Ma 87zVaid0emZ2Dm8FeOYXHNi+qDCnjF1yupbxZsOzsrq2rs0mxG4XKd2QNrcAtnd299wTwoJDe5wQ URQp7HsOXACHR67jk1OzLCpTKooMwHsmnQNcMEkeINOlxgyZ+a6uMWMFzF2IdKOtzs/es1uVQbrD rdfV67fDsD3A8lJ+LY+x+4cgP1rCmPkAnlR/boYwx+TEv1jRy9HrKkSKt/cPdOdn8Vd/JPY4XUpR 8j0VgTekd7UqdQjh/OA5CJRl8N/xA1KiTRL1M49PAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDI0LTA4 LTA5VDA5OjIwOjUyKzAwOjAwhGFKzQAAACV0RVh0ZGF0ZTptb2RpZnkAMjAyNC0wOC0wOVQwOToy MDo1MiswMDowMPU88nEAAAAodEVYdGRhdGU6dGltZXN0YW1wADIwMjQtMDgtMDlUMDk6MjE6MTUr MDA6MDAMBojkAAAAAElFTkSuQmCC" />
              </svg>
            </a>
          </el-tooltip>
          <!-- 智能助手入口（原 ChatGPT 服务已停止，跳转缙小虾） -->
          <el-tooltip content="智能助手（已迁移）" effect="dark" placement="bottom">
            <a href="javascript:;" class="right-menu-item medium-priority" @click.prevent="openJinxiaoxia('gpt3')">
              <svg t="1710401571770" class="icon cl1" viewBox="0 0 1089 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1641" width="20" height="20"><path d="M466.63477617 31.24645905c61.12522043 0.88373813 118.42090898 24.45008817 165.40631938 71.43549856 6.92261532 6.92261532 12.96149253 8.54280189 22.24074285 7.21719472 134.77006433-19.00036972 253.04368363 66.13306981 277.78835118 200.01939602 6.48074626 35.20223538 4.41869063 70.25718107-5.59700813 104.57567833-2.50392469 8.3955122-0.88373813 13.69794096 4.56598031 20.32597691 111.49829366 136.83211996 44.7760651 343.77413131-125.63810368 388.84477577-9.72111939 2.50392469-13.99252034 6.92261532-17.38018316 15.75999661-63.33456576 164.66987094-276.02087492 209.00406699-400.03879204 83.36596328-6.1861669-6.1861669-11.48859565-7.51177407-19.88410786-6.33345656-136.68483027 19.2949491-255.10573925-65.98578013-279.55582743-201.34500323-6.33345658-34.7603663-3.97682157-69.37344294 6.03887721-103.25007113 2.50392469-8.3955122 0.88373813-13.69794096-4.41869062-20.32597692-111.94016272-136.97940963-44.03961664-345.39431787 126.96371087-389.28664484 8.54280189-2.20934532 12.51962347-5.89158752 15.6127069-13.84523064 36.82242196-96.32745582 126.22726243-157.59996593 233.89602422-157.15809688z m148.17342591 593.13557275c-77.32708608 44.6287754-152.1502475 87.49007455-226.38425013 131.08782212-16.79102442 9.86840908-31.07812413 9.5738297-47.86914855-0.29457938-58.17942668-34.46578693-116.80072242-67.90054606-175.42201815-101.48259488-4.27140094-2.35663501-7.80635344-7.2171947-14.58167908-5.15513907-7.95364315 71.58278827 14.4343894 131.23511182 73.20297482 173.50725221 59.2104545 42.56671978 124.3124965 47.86914853 188.82537976 13.69794097 65.98578013-34.907656 129.76221494-74.08671296 194.42238788-111.49829366 3.68224221-2.06205563 7.80635344-3.68224221 7.80635345-9.13196065v-90.73044766z m-41.24111259-487.38157692c-1.47289687-5.15513907-5.30242877-6.62803595-8.24822251-8.69009157-58.91587511-39.9155054-121.66128212-46.24896197-185.29042725-14.87625848-64.21830387 31.81457257-98.38951143 86.16446736-100.30427737 157.89454531-1.91476594 72.90839547-0.29457937 145.81679091-0.73644845 218.72518637 0 7.80635344 2.65121438 11.93046471 9.27925032 15.46541723 21.65158411 11.93046471 43.00858883 24.59737787 64.36559358 36.82242194 2.65121438 1.47289687 5.0078494 4.71327001 9.42654001 1.91476595 0-86.31175705 0.29457937-173.06538315-0.14728967-259.81900928-0.1472897-17.82205222 6.62803595-29.31064787 22.09345315-38.00073943 44.7760651-25.18653662 89.11026111-51.10952167 133.59174684-76.88521704 18.70579035-10.75214722 37.4115807-21.79887379 55.97008135-32.551021z m85.28072925 341.56478599v18.85308004c0 81.89306641-0.1472897 163.93342252 0.14728967 245.82648892 0.1472897 16.64373472-6.03887719 27.98504069-20.62055629 35.93868382-20.47326659 11.19401627-40.50466414 23.12448098-60.68335137 34.76036634-43.45045791 25.18653662-87.04820548 50.37307323-134.62277464 77.91624483 4.12411126 1.47289687 6.1861669 1.76747625 7.65906377 2.94579376 54.64447417 39.9155054 114.29679772 49.04746604 176.89491503 24.00821909 62.5981173-25.03924691 102.95549177-72.6138161 110.61455554-139.63062402 9.27925033-81.89306641 1.91476594-164.66987094 3.3876628-247.00480644 0.1472897-4.41869063-1.91476594-6.92261532-5.44971843-8.98467094-25.03924691-14.4343894-49.93120416-28.86877882-77.32708608-44.6287754zM554.71400945 367.2142369c6.03887719 3.68224221 10.16298847 6.03887719 14.13981004 8.39551221 71.2882089 41.24111259 142.42912809 82.62951485 214.01191636 123.42875836 15.46541722 8.83738127 22.09345317 20.47326659 21.94616348 38.14802915-0.44186907 68.19512544-0.1472897 136.39025089-0.14728969 204.58537633 0 5.0078494 0.44186907 9.86840908 0.73644844 15.90728628 3.68224221-1.3256072 5.89158752-2.06205563 8.10093282-2.94579374 64.0710142-29.75251694 102.07175363-79.6837211 108.11063085-149.79361249 6.33345658-72.6138161-22.68261193-130.94053245-84.98614986-169.38314097-62.745407-38.73718787-127.55286961-74.08671296-191.32930443-111.20371428-5.59700814-3.24037312-9.72111939-3.68224221-15.61270692-0.29457938-24.15550879 14.13981003-48.60559698 27.83775099-74.97045109 43.15587853zM216.24230691 270.44491203c-6.62803595-0.88373813-10.60485751 2.20934532-14.72896877 4.27140094-60.97793075 30.63625506-96.62203518 80.12559015-102.21904332 147.87884654-5.74429781 70.25718107 21.50429441 127.9947387 81.15661796 165.70089876 63.92372449 40.35737445 130.64595307 76.44334797 196.04257446 114.44408742 3.82953187 2.20934532 7.36448439 4.12411126 11.78317501 1.47289688 25.33382629-14.72896878 50.66765259-29.45793756 77.47437578-44.92335477-5.59700814-3.38766283-9.42654002-5.89158752-13.40336158-8.24822253-71.2882089-41.24111259-142.42912809-82.62951485-214.01191636-123.28146868-16.05457598-9.13196064-22.53532223-21.06242535-22.38803255-39.32634664 0.58915875-72.31923671 0.29457937-144.7857631 0.29457937-217.98873792z m190.15098694 130.79324274c6.1861669-3.24037312 10.31027814-5.30242877 14.28709973-7.65906375 70.55176044-40.65195383 141.25081059-81.00932829 211.36070197-122.39773056 16.79102442-9.86840908 31.07812413-10.16298847 47.86914854-0.29457937 59.0631648 34.907656 118.56819867 68.78428419 177.92594284 102.95549177 3.5349525 2.06205563 6.48074626 5.89158752 12.51962347 4.12411125 7.80635344-70.10989139-13.40336159-129.32034589-70.69905013-171.73977596-59.50503387-44.18690634-125.34352431-50.22578353-191.03472509-15.6127069-65.98578013 34.907656-129.76221494 74.08671296-194.56967756 111.35100396-3.68224221 2.06205563-7.65906378 3.82953187-7.65906377 9.27925033v89.99399923z m208.41490823 115.9169843c0-20.17868721-0.44186907-36.96971163 0.14728969-53.61344636 0.29457937-7.65906378-2.20934532-12.0777544-8.98467096-15.75999658-29.45793756-16.49644503-58.76858542-33.43475913-87.78465391-50.6676526-5.59700814-3.38766283-9.72111939-3.38766283-15.46541723-0.14728971-29.01606849 17.23289347-58.32671636 34.17120756-87.78465393 50.66765261-6.77532564 3.82953187-8.83738127 8.24822251-8.83738127 15.90728628 0.44186907 32.84560039 0.58915875 65.83849045 0 98.68409082-0.1472897 8.98467097 3.09308345 13.69794096 10.75214722 17.67476253 13.99252034 7.2171947 27.24859225 15.61270692 40.94653321 23.41906036 17.38018317 9.86840908 34.7603663 27.6904613 51.99325978 27.54317163 17.96934191-0.1472897 35.79139413-17.52747284 53.46615667-27.54317163 16.9383141-9.72111939 39.17905696-16.20186565 48.75288666-30.78354473 9.86840908-15.46541722 1.76747625-39.03176725 2.79850407-55.38092262z" fill="#030303" p-id="1642" /></svg>
            </a>
          </el-tooltip>
          <!-- chatGPT4 入口 -->
          <el-tooltip v-if="checkPermission(['chatGPT4'])" content="智能助手（已迁移）" effect="dark" placement="bottom">
            <a href="javascript:;" class="right-menu-item medium-priority" @click.prevent="openJinxiaoxia('gpt4')">
              <svg t="1710403673609" class="icon cl1" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3544" width="20" height="20"><path d="M357.441536 503.998464l54.719488 31.039488 0.319488-179.837952c0-7.359488 4.159488-14.399488 10.559488-17.92l128.958464-73.598976 3.84-2.240512c-36.48-29.759488-86.719488-36.159488-129.278976-16.319488-42.559488 19.519488-69.758976 61.759488-70.079488 108.479488v149.118976c0.001024 0.319488 0.321536 0.959488 0.961536 1.278976z" fill="#313538" p-id="3545" /><path d="M441.920512 551.998464L512 591.997952l70.398976-39.999488v-79.998976L512 432l-70.079488 39.999488z" fill="#313538" p-id="3546" /><path d="M295.682048 565.757952l130.558976 74.559488c0.64 0.319488 1.28 0.319488 1.92 0l54.4-31.039488-157.758464-89.919488c-6.4-3.519488-10.559488-10.559488-10.559488-17.92V349.44a121.7536 121.7536 0 0 0-63.36 52.48c0 0.64-0.319488 0.959488-0.64 1.599488-32.320512 57.279488-12.161024 129.918976 45.438976 162.238464zM441.920512 376.000512v62.399488l157.758464-89.919488c6.4-3.84 14.399488-3.84 21.12 0l129.278976 73.598976 3.84 2.239488c7.68-46.08-12.16-92.479488-50.56-118.718464-38.719488-26.559488-89.279488-28.8-130.238464-5.439488l-130.558976 74.238976c-0.319488 0.320512-0.64 0.960512-0.64 1.600512zM666.558464 519.678976l-54.719488-31.039488V668.47744c0 7.359488-4.159488 14.399488-10.559488 17.92l-129.278976 73.598976-3.84 2.240512c22.079488 17.92 49.28 27.839488 77.759488 27.839488 67.198976 0 121.278464-53.76 121.598976-119.998464V521.278464c0-0.64-0.320512-1.28-0.960512-1.599488z" fill="#313538" p-id="3547" /><path d="M512 0C229.230592 0 0 229.230592 0 512s229.230592 512 512 512 512-229.230592 512-512S794.769408 0 512 0z m297.91744 642.87744c-23.04 39.999488-62.399488 68.478976-107.839488 77.438976-22.4 66.879488-85.118976 111.998976-155.518976 111.679488h-1.599488c-46.08 0.319488-90.238976-19.2-120.958976-53.439488-69.118976 14.72-140.158976-16.319488-175.997952-77.438976-23.359488-39.359488-28.479488-87.359488-13.759488-130.878464-47.679488-51.84-55.68-128.638976-20.159488-189.118464a163.003392 163.003392 0 0 1 108.158976-77.438976c22.4-66.879488 85.118976-111.998976 155.518976-111.679488h1.28c46.08 0 89.919488 19.2 120.958976 53.439488 69.118976-14.72 140.158976 16.319488 175.998976 77.438976 23.359488 39.359488 28.479488 87.359488 13.759488 130.878464 47.678464 52.159488 55.677952 128.638976 20.158464 189.118464z" fill="#313538" p-id="3548" /><path d="M582.398976 647.99744v-62.399488l-157.758464 89.919488c-6.4 3.84-14.399488 3.84-21.12 0l-129.278976-73.598976-3.84-2.240512c-4.800512 27.839488 0.319488 55.999488 14.399488 80.319488 34.56 57.279488 108.158976 77.119488 166.398976 44.16l130.558976-74.559488c0.320512-0.320512 0.64-0.960512 0.64-1.600512zM728.638464 458.238976L598.079488 384c-0.64-0.319488-1.28-0.319488-1.92 0l-54.4 31.039488 157.758464 89.919488c6.4 3.519488 10.24 10.559488 10.559488 17.599488v151.998464a119.063552 119.063552 0 0 0 63.998976-53.76c32.320512-57.278464 11.841536-130.23744-45.437952-162.557952z" fill="#313538" p-id="3549" /></svg>  </a>
          </el-tooltip>
        </div>
        <!-- IT工单 -->
        <el-tooltip content="IT工单" effect="dark" placement="bottom">
          <a target="_blank" class="right-menu-item" href="https://fk5i1eajro.feishu.cn/share/base/form/shrcnSFfgx2AYhActPRLMb7MPzh">
            <svg t="1679299745460" class="icon cl1" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3156" width="20" height="20"><path d="M464 784.352c0 26.51 21.49 48 48 48s48-21.49 48-48-21.49-48-48-48-48 21.49-48 48z" p-id="3157" fill="#3bd1b4" /><path d="M512 960C264.96 960 64 759.04 64 512S264.96 64 512 64s448 200.96 448 448-200.96 448-448 448z m0-831.713c-211.584 0-383.713 172.129-383.713 383.713 0 211.552 172.129 383.713 383.713 383.713 211.552 0 383.713-172.16 383.713-383.713 0-211.584-172.161-383.713-383.713-383.713z" p-id="3158" fill="#3bd1b4" /><path d="M512 673.695c-17.665 0-32-14.336-32-31.999v-54.112c0-52.353 39.999-92.352 75.327-127.648 25.887-25.92 52.672-52.672 52.672-74.016 0-53.344-43.072-96.736-95.999-96.736-53.823 0-96 41.536-96 94.56 0 17.664-14.335 31.999-32 31.999s-32-14.336-32-32c0-87.423 71.774-158.559 160-158.559S672 297.28 672 385.92c0 47.904-36.32 84.191-71.424 119.296-27.84 27.776-56.575 56.512-56.575 82.335v54.112c0 17.665-14.336 32.032-32.001 32.032z" p-id="3159" fill="#3bd1b4" /></svg>
          </a>
        </el-tooltip>
        <el-tooltip content="全屏" effect="dark" placement="bottom">
          <screenfull class="screenfull right-menu-item" />
        </el-tooltip>
        <el-tooltip content="布局大小" effect="dark" placement="bottom">
          <size-select class="right-menu-item" />
        </el-tooltip>
        <el-dropdown class="right-menu-item" placement="bottom-start" trigger="click">
          <span @click="GetCollect()">
            收藏
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu v-if="collectList.length>0" slot="dropdown">
            <el-dropdown-item v-for="(item,index) in collectList" :key="index">
              <span class="flex_between_center padding-content">
                <router-link :to="item.path"> {{ item.title }}
                  <i class="el-icon-arrow-right"></i>
                </router-link>
                <i class="el-icon-delete pl-5" @click="deleteCollect(item)"></i>
              </span>
            </el-dropdown-item>
          </el-dropdown-menu>
          <el-dropdown-menu v-else slot="dropdown">
            <el-dropdown-item>
              <span class="flex_between_center padding-content">
                标签右键可以添加收藏
              </span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <el-dropdown class="avatar-container right-menu-item" trigger="click">
        <div class="avatar-wrapper">
          <img :src="pianoRabbitUrl" class="user-avatar" alt="User Avatar" />
          <i class="el-icon-caret-bottom"></i>
        </div>
        <el-dropdown-menu slot="dropdown">
          <router-link to="/">
            <el-dropdown-item>
              首页
            </el-dropdown-item>
          </router-link>
          <router-link to="/system/myRoleList">
            <el-dropdown-item>
              我的权限
            </el-dropdown-item>
          </router-link>
          <el-dropdown-item @click.native="editPassword">
            修改密码
          </el-dropdown-item>
          <el-dropdown-item v-if="checkPermission(['developer'])&&(environment=='development'||environment=='sit')" @click.native="openDialog">
            调试地址
          </el-dropdown-item>
          <!-- 财务归档环境切换 -->
          <el-dropdown-item v-if="checkPermission(['ArchiveTag'])&&!isArchiveEnv" divided @click.native="switchToArchive">
            <i class="el-icon-folder-opened"></i> 切换到归档环境
          </el-dropdown-item>
          <el-dropdown-item v-if="checkPermission(['ArchiveTag'])&&isArchiveEnv" divided @click.native="switchToProduction">
            <i class="el-icon-folder"></i> 切换到正式环境
          </el-dropdown-item>
          <a target="_blank" href="http://wiki.shjinjia.com.cn/index.php?title=%E9%A6%96%E9%A1%B5">
            <el-dropdown-item>
              帮助文档
            </el-dropdown-item>
          </a>
          <el-dropdown-item divided>
            <span style="display:block;" @click="logout">退出登录</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <!-- 调试地址 -->
    <ApiSite ref="ApiSite" />
    <el-dialog v-if="dialogTableVisible" :visible.sync="dialogTableVisible" :append-to-body="true" title="修改密码">
      <el-form ref="detail" :model="detail" :rules="detailrules" label-width="150px" class="demo-ruleForm">
        <el-form-item label="原密码" prop="oldpassword">
          <el-input v-model="detail.oldpassword" v-trim type="password" />
        </el-form-item>
        <el-form-item label="新密码" prop="newpassword">
          <el-input v-model="detail.newpassword" v-trim type="password" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitdetail('detail')">确认</el-button>
          <el-button @click="resetdetail('detail')">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { GetMyFavorites, DeleteFromMyFavorite } from '@/api/common'
import { ChangePassword } from '@/api/login'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
import Screenfull from '@/components/Screenfull'
import SizeSelect from '@/components/SizeSelect'
import Search from '@/components/HeaderSearch'
import checkPermission from '@/utils/permission' // 权限判断函数
import ApiSite from './ApiSite'
import { logoutFn } from '@/utils/logout'
import { isMobilePlatform } from '@/utils/index'

export default {
  components: {
    Breadcrumb,
    Hamburger,
    Screenfull,
    SizeSelect,
    Search,
    ApiSite
  },
  data() {
    return {
      collectList: [],
      environment: process.env.NODE_ENV,
      dialogTableVisible: false,
      detail: {
        oldpassword: '',
        newpassword: ''
      },
      baseApiData: {},
      isMobile: false,
      BASE_CHATGPT3_API: process.env.BASE_CHATGPT3_API,
      BASE_CHATGPT4_API: process.env.BASE_CHATGPT4_API,
      chatGpt3Url: 'chatGPT3/1002',
      chatGpt4Url: 'chatGPT4/1002',
      BASE_JINXIAOXIA_URL: process.env.BASE_JINXIAOXIA_URL,
      pianoRabbitUrl: require('@/assets/pianoRabbit.gif'), // 使用相对路径
      isArchiveEnv: false,
      BASE_ARCHIVE_API: process.env.BASE_ARCHIVE_API
    }
  },
  computed: {
  /* eslint-disable*/
    detailrules: function() {
      var checknewpassword = (rule, value, callback) => {
        setTimeout(() => {
          if (this.detail.oldpassword == this.detail.newpassword) {
            callback(new Error('新密码和老密码不能一样'))
          } else {
            var str = value
            if (str == null || str.length < 8) {
              callback(new Error('密码不能少于8位'))
            }
            var reg = new RegExp(/[A-Za-z].*[0-9]|[0-9].*[A-Za-z]/)
            if (reg.test(str)) {
              callback()
            } else {
              callback(new Error('密码必须同时包含字母和数字'))
            }
          }
        }, 100)
      }
      var rules = {
        oldpassword: [
          {
            required: true,
            message: '请输入原密码',
            trigger: 'blur'
          }
        ],
        newpassword: [
          {
            required: true,
            message: '请输入新密码',
            trigger: 'blur'
          },
          {
            validator: checknewpassword,
            trigger: 'blur'
          }
        ]
      }
      return rules
    },
    ...mapGetters(['sidebar', 'name', 'avatar', 'device', 'userinfo'])
  },
  mounted() {
    this.baseApiData = JSON.parse(localStorage.getItem('baseApiData'))
    // 判断浏览器
    this.isMobile = isMobilePlatform()
    // 恢复归档环境状态（使用sessionStorage，窗口关闭自动清除）
    var savedArchiveEnv = sessionStorage.getItem('isArchiveEnv')
    console.log('[归档环境] mounted - sessionStorage值:', savedArchiveEnv)
    if (savedArchiveEnv === 'true') {
      this.isArchiveEnv = true
      console.log('[归档环境] mounted - 已恢复归档环境状态')
    } else {
      this.isArchiveEnv = false
      console.log('[归档环境] mounted - 正式环境状态')
    }
  },
  methods: {
    logoutFn,
    openJinxiaoxia(source = 'gpt4') {
      const jinxiaoxiaUrl = this.BASE_JINXIAOXIA_URL
      const legacyBase = source === 'gpt3' ? this.BASE_CHATGPT3_API : this.BASE_CHATGPT4_API
      const legacyPath = source === 'gpt3' ? this.chatGpt3Url : this.chatGpt4Url
      const legacyUrl = `${legacyBase || ''}${legacyPath || ''}`
      const msg = `
        <div class="jx-migration">
          <div class="jx-migration__desc">
            本ChatGPT服务已正式到期，后续所有服务将由【缙小虾】为您继续提供服务。如需导出对话数据，请在30天内自行处理。
          </div>
        </div>
      `

      this.$confirm(msg, '提示', {
        confirmButtonText: '前往缙小虾继续使用',
        cancelButtonText: '继续前往',
        type: 'warning',
        dangerouslyUseHTMLString: true,
        customClass: 'jinxiaoxia-migration-dialog',
        distinguishCancelAndClose: true
      }).then(() => {
        if (jinxiaoxiaUrl) {
          window.open(jinxiaoxiaUrl, '_blank', 'noopener,noreferrer')
        } else {
          this.$message({
            type: 'error',
            message: '未配置缙小虾跳转地址（BASE_JINXIAOXIA_URL）'
          })
        }
      }).catch(action => {
        if (action === 'cancel') {
          if (legacyUrl) {
            window.open(legacyUrl, '_blank', 'noopener,noreferrer')
          } else {
            this.$message({
              type: 'error',
              message: '未配置原服务跳转地址'
            })
          }
        }
      })
    },
    toggleSideBar() {
      this.$store.dispatch('toggleSideBar')
    },
    logout() {
      process.env.NODE_ENV === 'development' ? this.$store.dispatch('LogOut').then(() => {
        location.reload() // In order to re-instantiate the vue-router object to avoid bugs
      }) : logoutFn()
    },
    GetCollect() {
      GetMyFavorites({ system_id: '2' }).then(response => {
        if (response.data.res_status_code == 0) {
          this.collectList = response.data.res_content
        } else {
          this.$message({
            type: 'error',
            message: response.data.res_message
          })
        }
      })
    },
    deleteCollect(item) {
      item.system_id = '2'
      DeleteFromMyFavorite(item).then(response => {
        if (response.data.res_status_code == 0) {
          this.$message({
            type: 'success',
            message: this.$t('message.operatesuc')
          })
          this.GetCollect()
        } else {
          this.$message({
            type: 'error',
            message: response.data.res_message
          })
        }
      })
    },
    openDialog() {
      this.$nextTick(() => {
        this.$refs.ApiSite.handleOpen()
      })
    },
    goOfficial() {
      window.location = 'https://oak.shjinjia.com.cn'
    },
    checkPermission,
    /**
     * @description: 修改密码
     * @param {type}
     * @return {type}
     */
    editPassword() {
      this.dialogTableVisible = true
      this.resetdetail('detail')
    },
    /**
     * @description: 修改密码
     * @param {type}
     * @return {type}
     */
    submitdetail(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          var data = {}
          data.login_id = this.userinfo.login_id
          data.origin_pwd = this.detail.oldpassword
          data.pwd = this.detail.newpassword
          ChangePassword(data).then(response => {
            if (+response.data.res_status_code === 0) {
              this.$message({
                type: 'success',
                message: '修改成功，请重新登录',
                duration: 2000,
                onClose: () => {
                  this.dialogTableVisible = false
                  this.loading = false
                  this.logout()
                }
              })
            } else {
              this.loading = false
              this.$message({
                type: 'error',
                message: response.data.res_message
              })
            }
          })
        } else {
          return false
        }
      })
    },
    // 清空form
    resetdetail(formName) {
      if (this.$refs[formName] !== undefined) {
        this.$refs[formName].resetFields()
      }
    },
    /**
     * @description: 切换到归档环境
     * @author: domiyoung
     */
    switchToArchive() {
      this.$confirm('切换到归档环境将查询历史财务数据，是否继续？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.isArchiveEnv = true
        sessionStorage.setItem('isArchiveEnv', 'true')
        console.log('[归档环境] 已设置sessionStorage:', sessionStorage.getItem('isArchiveEnv'))
        this.$message({
          type: 'success',
          message: '已切换到归档环境'
        })
        // 刷新页面以应用新环境配置
        setTimeout(() => {
          location.reload()
        }, 500)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消切换'
        })
      })
    },
    /**
     * @description: 切换到正式环境
     * @author: domiyoung
     */
    switchToProduction() {
      this.isArchiveEnv = false
      sessionStorage.removeItem('isArchiveEnv')
      this.$message({
        type: 'success',
        message: '已切换到正式环境'
      })
      // 刷新页面以应用新环境配置
      location.reload()
    },
    /**
     * @description: 归档环境提示点击 - 快速切换回正式环境
     * @author: domiyoung
     */
    goArchiveOfficial() {
      this.switchToProduction()
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
/* 响应式断点定义 */

/deep/ .jinxiaoxia-migration-dialog {
  width: 520px;
  max-width: calc(100vw - 32px);
  border-radius: 12px;
}

/deep/ .jinxiaoxia-migration-dialog .el-message-box__header {
  padding: 16px 20px 0;
}

/deep/ .el-message-box.jinxiaoxia-migration-dialog {
  width: 560px !important; // 你想要的宽度
  max-width: calc(100vw - 32px);
}

/deep/ .jinxiaoxia-migration-dialog .el-message-box__title {
  font-size: 16px;
  font-weight: 600;
  color: #1f2d3d;
}

/deep/ .jinxiaoxia-migration-dialog .el-message-box__content {
  padding: 10px 20px 0;
}

/deep/ .jinxiaoxia-migration-dialog .el-message-box__message {
  margin: 0;
}

/deep/ .jinxiaoxia-migration-dialog .el-message-box__status {
  top: 22px;
  transform: none;
}

/deep/ .jinxiaoxia-migration-dialog .jx-migration {
  line-height: 1.6;
}

/deep/ .jinxiaoxia-migration-dialog .jx-migration__desc {
  font-size: 13px;
  color: #606266;
}

/deep/ .jinxiaoxia-migration-dialog .el-message-box__btns {
  padding: 16px 20px 18px;
}

/deep/ .jinxiaoxia-migration-dialog .el-button--primary {
  border-radius: 10px;
  padding-left: 16px;
  padding-right: 16px;
}

/deep/ .jinxiaoxia-migration-dialog .el-button--default {
  border-radius: 10px;
}
$mobile-breakpoint: 768px;
$tablet-breakpoint: 1200px;

/* Material Design 设计令牌 */
$primary-color: #1976d2;
$surface-color: #ffffff;
$on-surface: #212121;
$on-surface-variant: #757575;
$spacing-unit: 8px;

.navbar {
  height: 56px;
  line-height: 56px;
  border-radius: 0 !important;
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  padding: 0 16px;
  min-width: 0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  background: $surface-color;
  /* 响应式高度调整 */
  @media (max-width: $mobile-breakpoint) {
    height: 48px;
    line-height: 48px;
    padding: 0 12px;
  }

  .navbar-left {
    display: flex;
    align-items: center;
    flex: 1 1 auto;
    min-width: 0;
    overflow: hidden;
    gap: #{$spacing-unit * 2};
  }

  .hamburger-container {
    display: flex;
    align-items: center;
    height: 56px;
    padding: 0 #{$spacing-unit * 2};
    flex-shrink: 0;
    @media (max-width: $mobile-breakpoint) {
      height: 48px;
      padding: 0 $spacing-unit;
    }
  }
  .breadcrumb-container {
    flex: 1 1 auto;
    min-width: 0;
    overflow: hidden;
  }
  .env-alert-container {
    display: flex;
    align-items: center;
    flex-shrink: 0;
    min-width: 0;
    max-width: 240px;

    @media (max-width: $mobile-breakpoint) {
      display: none;
    }

    .env-alert {
      width: 100%;

      /deep/ .el-alert__content {
        padding: 4px 8px;
        overflow: hidden;
      }
      /deep/ .el-alert__title {
        font-size: 12px;
        line-height: 1.2;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
  .right-menu {
    margin-left: auto;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    height: 100%;
    gap: #{$spacing-unit * 2};

    &:focus {
      outline: none;
    }

    @media (max-width: $mobile-breakpoint) {
      gap: $spacing-unit;
    }

    .right-menu-actions {
      display: flex;
      align-items: center;
      flex-shrink: 0;
      gap: inherit;
    }

    .search-section {
      flex-shrink: 0;
      .search-component {
        display: block;
      }

      @media (max-width: $mobile-breakpoint) {
        display: none;
      }
    }
    /* 用户信息区域 */
    .user-info-section {
      display: flex;
      align-items: center;
      flex-shrink: 0;
      gap: #{$spacing-unit};
      .welcome-text {
        font-size: 13px;
        color: $on-surface;
        white-space: nowrap;
        display: flex;
        align-items: center;
        line-height: 1;
        letter-spacing: 1px;

        @media (max-width: $tablet-breakpoint) {
          font-size: 12px;
        }

        @media (max-width: $mobile-breakpoint) {
          display: none;
        }

        .name-shimmer {
          display: inline-block;
          color: $primary-color;
          font-weight: 500;
          position: relative;
          overflow: hidden;
          &::before {
            content: '';
            position: absolute;
            top: 150%;
            left: -150%;
            width: 200%;
            height: 200%;
            background: linear-gradient(
              45deg,
              transparent 0%,
              rgba(255, 255, 255, 0.2) 40%,
              rgba(255, 255, 255, 0.6) 50%,
              rgba(255, 255, 255, 0.2) 60%,
              transparent 100%
            );
            animation: diagonalFlow 5s ease-in-out infinite;
            pointer-events: none;
          }
          @media (max-width: $mobile-breakpoint) {
            display: none;
          }
        }
      }
      .env-indicator {
        font-size: 12px;
        color: $on-surface;
        background: transparent;
        border-radius: 12px;
        white-space: nowrap;
        max-width: 140px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: flex;
        align-items: center;
        line-height: 1;
        @media (max-width: $tablet-breakpoint) {
          max-width: 80px;
          padding: 2px 6px;
          font-size: 12px;
        }
        @media (max-width: $mobile-breakpoint) {
          max-width: 60px;
        }
      }
    }
    .right-menu-item {
      display: inline-flex;
      align-items: center;
      margin: 0;
      flex-shrink: 0;

      &.medium-priority {
        @media (max-width: $mobile-breakpoint) {
          display: none;
        }
      }
    }
    .screenfull {
      height: 16px;
      width: 16px;
    }

    .size-select {
      height: 16px;
      width: 16px;

      /deep/ .size-select-component {
        height: 16px;
        width: 16px;
      }
    }
    .international,
    .theme-switch {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .avatar-container {
      height: 56px;
      flex-shrink: 0;
      display: flex;
      align-items: center;
      margin-left: $spacing-unit;

      @media (max-width: $mobile-breakpoint) {
        height: 48px;
      }

      .avatar-wrapper {
        cursor: pointer;
        position: relative;
        display: flex;
        align-items: center;
        .user-avatar {
          width: 32px;
          height: 32px;
          border-radius: 50%;
          transition: transform 0.2s cubic-bezier(0.4, 0.0, 0.2, 1);

          &:hover {
            transform: scale(1.05);
          }

          @media (max-width: $mobile-breakpoint) {
            width: 32px;
            height: 32px;
          }
        }
        .el-icon-caret-bottom {
          position: absolute;
          right: -14px;
          top: 50%;
          transform: translateY(-50%);
          font-size: 12px;
          color: $on-surface-variant;
          @media (max-width: $mobile-breakpoint) {
            right: -16px;
          }
        }
      }
    }
    /* 工具区域 */
    .tools-section {
      display: flex;
      align-items: center;
      gap: #{$spacing-unit}; // 减小工具间距到8px
      flex-shrink: 0;

      @media (max-width: $tablet-breakpoint) {
        gap: #{$spacing-unit / 2}; // 中屏4px间距
      }

      @media (max-width: $mobile-breakpoint) {
        display: none;
      }
    }
  }
}

/* 工具图标样式优化 */
.cl1, .cl10 {
  transition: all 0.2s cubic-bezier(0.4, 0.0, 0.2, 1);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  &:hover {
    transform: scale(1.05); // 减少缩放效果，更加优雅
    opacity: 0.8;
  }
}

/* 确保所有工具链接都垂直居中 */
.right-menu-item a {
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
}

/* 确保tooltip包装的元素也垂直居中 */
.el-tooltip {
  display: flex;
  align-items: center;
}

/* 确保下拉菜单也垂直居中 */
.el-dropdown {
  display: flex;
  align-items: center;
  > span {
    display: flex;
    align-items: center;
    font-size: 12px;
    cursor: pointer;
  }
}

/* 确保screenfull和size-select垂直居中 */
.screenfull, .size-select {
  display: flex;
  align-items: center;
  justify-content: center;
}

.bilogo {
  width: 50px;
  height: 50px;
}

@media (min-width: #{$mobile-breakpoint + 1px}) and (max-width: $tablet-breakpoint) {
  .navbar .right-menu {
    gap: $spacing-unit;
  }
}

/* 白色对角线流动发光动画 */
@keyframes diagonalFlow {
  0% {
    top: 150%;
    left: -150%;
  }
  70% {
    top: -50%;
    left: 50%;
  }
  100% {
    top: -50%;
    left: 50%;
  }
}
</style>

<style lang="scss">
/* MessageBox 挂载在 body 下，使用全局样式确保覆盖默认 420px 宽度 */
.el-message-box.jinxiaoxia-migration-dialog {
  width: 465px !important;
  max-width: calc(100vw - 32px) !important;
}
</style>
